import CryptoJS from "crypto-js";
import config from "../config/config";
const SECRET_KEY = config.SECRET_KEY;

/**
 * Encrypts the given data using AES encryption.
 * @param {any} data - The data to encrypt.
 * @returns {string} - The encrypted string.
 */
export const encryptData = (data) => {
    try {
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return encryptedData;
    } catch (error) {
        console.error("Encryption error:", error);
        return null;
    }
};

/**
 * Decrypts the given encrypted string using AES decryption.
 * @param {string} encryptedData - The encrypted string.
 * @returns {any} - The decrypted data, or null if decryption fails.
 */
export const decryptData = (encryptedData) => {
    if (!encryptedData) return null;

    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return decryptedData;
    } catch (error) {
        console.error("Decryption error:", error);
        return null; // Return null or handle the error as needed
    }
};
